import { format, parseISO } from 'date-fns';
import toDate from 'date-fns/fp/toDate/index.js';

/**
 * ���t�̃t�H�[�}�b�g�i�������Ԃ��j
 * @param date - �Ώۓ��t
 * @param type - �t�H�[�}�b�g�`��
 * @return �t�H�[�}�b�g��̓��t������
 */
export const formatDate = (date: string, type: string): string => {
    try {
        if (date == null || date.trim() == '') {
            return '';
        } else {
            const dateObject = new Date(date);
            return format(dateObject, type)
        }
    } catch {
        return '';
    }
}

